import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Snackbar, SnackbarState } from './types'
import { RootState } from '..'

const initialState: SnackbarState = {
  snackbarAtiva: {
    open: false,
    severity: 'info',
    message: ''
  }
}

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    setSnackbarAtiva: (state, action: PayloadAction<Snackbar>) => {
      state.snackbarAtiva = action.payload
    },
    unsetSnackbarAtiva: state => {
      state.snackbarAtiva = initialState.snackbarAtiva
    }
  }
})

export const { setSnackbarAtiva, unsetSnackbarAtiva } = snackbarSlice.actions
export const snackbarReducer = snackbarSlice.reducer
export const selectSnackbarAtiva = (state: RootState) =>
  state.snackbar.snackbarAtiva
